// extracted by mini-css-extract-plugin
module.exports = {"addressName":"client_addressName__2QuY3","addressSmall":"client_addressSmall__25lpT"};